// extracted by mini-css-extract-plugin
export default {"primaryButton":"primaryButton__K8l44","backButton":"backButton__2Z8Zq"};
    if(module.hot) {
      // 1790586294222
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  